import { render } from "./LanguagePackage.vue?vue&type=template&id=11a17ec4&scoped=true"
import script from "./LanguagePackage.vue?vue&type=script&lang=js"
export * from "./LanguagePackage.vue?vue&type=script&lang=js"

import "./language-package.scss?vue&type=style&index=0&id=11a17ec4&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\hrportal\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11a17ec4"]])

export default __exports__